import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { APICall } from "../../../Helpers/API/APICalls";
import { debounceSearchRender } from "mui-datatables";
import {
  GetDropDownList,
  GetCompOffDataBasedId,
  UpdateCompOffRequestData,
} from "../../../Helpers/API/APIEndPoints";
import InputForm from "../../../Components/InputForm/InputForm";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import Heading from "../../../Components/Heading/Heading";
import { leaveTypeOptions } from "../../../Common/CommonJson";
import notify from "../../../Helpers/ToastNotification";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";
import { Form } from "react-bootstrap";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";

interface LocationState {
  compOffdate: any;
  id: number;
  role: string;
  leaveType: number;
  requestStatus: number;
  requestorId: number;
  approverId: number;
  requestorName: any;
  approverName: any;
  leaveBalance: any;
  StatusId: number;
  reason: any;
}

const CompOffLeaveMasterEdit = () => {
  let navigate = useNavigate();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const location = useLocation();
  const state = location.state as LocationState; // Type Casting, then you can get the params passed via router
  const [leaveDays, setLeaveDays] = useState(0);
  const [reason, setReason] = useState(state.reason || "");

  const [approverOptions, setApproverOptions] = useState<any>([]);
  const [approver, setApprover] = useState<any>({});
  const [fromDate, setFromDate] = React.useState<Date | null>(new Date());
  const [toDate, setToDate] = React.useState<Date | null>(new Date());
  const [formErrors, setFormErrors] = useState({});
  const [leaveStatusOnEdit, setLeaveStatusOnEdit] = useState(false);
  let formErrorObj = {};
  const [env, setEnv] = useState<any>(
    process.env.REACT_APP_PUBLISH_PATH ? process.env.REACT_APP_PUBLISH_PATH : ""
  );

  const { EmployeeId, EmployeeWorkPolicyId, RoleId } = getContext();
  const RoleIdArray = RoleId.split(",");
  const [canChangeRequestor, setCanChangeRequestor] = useState(false);
  const [requestor, setRequestor] = useState<any>({
    value: Number(EmployeeId),
  });
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [LeaveRequestMasterData, setLeaveRequestMasterData] = useState([]);
  useEffect(() => {
    debugger;
    if (state.reason !== reason) {
      setReason(state.reason || "");
    }
  }, [state.reason]);

  useEffect(() => {
    if (
      RoleIdArray.includes("3") ||
      RoleIdArray.includes("8") ||
      RoleIdArray.includes("4")
    ) {
      setCanChangeRequestor(true);
    }
  }, [RoleIdArray]);

  useEffect(() => {
    (async () => {
      await approverApiCall();
      await getLeaveRequestMasterData();
    })();
  }, []);

  useEffect(() => {
    if (state.approverId !== 0) {
      let req = approverOptions.find((ele) => ele.value === state.approverId);
      setApprover(req);
    }
  }, [state.approverId, approverOptions]);

  const approverApiCall = async () => {
    let postObject = {
      searchFor: "employee",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let approverArray = [];
      await data.map((approver: any) => {
        let tempObj = {
          eid: approver.eid,
          value: approver.id,
          label: approver.name,
          workPolicyID: approver.workPolicyId,
        };
        approverArray.push(tempObj);
      });

      setApproverOptions(approverArray);

      if (state.requestorId !== 0) {
        let requestor = approverArray.find(
          (ele) => ele.value === state.requestorId
        );
        setRequestor(requestor);
      }
    }
  };

  const submitApiCall = async (submitObj: any) => {
    showLoader();

    const { data, status, message } = await APICall(
      UpdateCompOffRequestData,
      "POST",
      submitObj
    );

    hideLoader();
    if (status === 0) {
      navigate(`${env}/master/CompOffLeaveRequest`);
      //change notification as per screen
      if (state.role === "self") {
        notify(0, "CompOff Cancelled !");
      } else if (state.role === "manager" && leaveStatusOnEdit === true) {
        notify(0, "CompOff Cancelled !");
      } else if (state.role !== "self" && leaveStatusOnEdit === true) {
        notify(0, "CompOff Approved !");
      } else if (state.role === "approver" && leaveStatusOnEdit === true) {
        notify(0, "CompOff Approved !");
      } else if (state.role === "approver" && leaveStatusOnEdit === false) {
        notify(1, "CompOff Rejected !");
      } else if (state.role !== "self" && leaveStatusOnEdit === false) {
        notify(1, "CompOff Rejected !");
      } else {
        notify(0, "CompOff Requested successfully");
      }
    } else if (
      state != null &&
      state.role === "self" &&
      data === 0 &&
      status === 0
    ) {
      notify(1, "CompOff cannot be cancelled  for backdated date ");
    } else {
      notify(1, message);
    }
  };

  const resetFunc = () => {
    setFormErrors({});
    setFromDate(null);
    setToDate(null);
    setLeaveDays(0);
    // setLeaveReason({});
    setReason("");
  };

  const handleTextEvent = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "reason") {
      setReason(event.target.value);
      setFormErrors((preState) => ({
        ...preState,
        ["reason_isEmpty"]: "",
      }));
      // if (
      //   event.target.value == undefined ||
      //   event.target.value == null ||
      //   event.target.value == ""
      // ) {
      // setFormErrors((preState) => ({
      //   ...preState,
      //   ["reason_isEmpty"]: "Reasons can not be empty",
      // }));
      // }
    }
  };

  const submitFunc = async (action: any) => {
    let submitObj: any = {};
    if (action === "submit") {
      if (state.id !== 0 && state !== null) {
        let leaveStatus = 0;

        if (state.role === "self") {
          leaveStatus = 4;
        } else if (state.role === "approver") {
          if (leaveStatusOnEdit) {
            leaveStatus = 1;
          } else {
            leaveStatus = 3;
          }
        } else if (state.role === "manager") {
          leaveStatus = 4;
        } else {
          leaveStatus = 1;
        }
        let formErrorObj: any = {};

        // Add Reason validation if Approve Comp-Off switch is false
        if (
          leaveStatusOnEdit === false &&
          (reason === "" || reason.trim() === "")
        ) {
          formErrorObj["reason_isEmpty"] =
            "Reason cannot be empty when rejecting Comp-Off";
        }

        // Update formErrors state
        setFormErrors(formErrorObj);
        let isEmpty = Object.values(formErrorObj).every(
          (f) => f === "" || f === null || f === undefined
        );
        if (isEmpty === true) {
          submitObj = {
            CompOffId: state.id, // @compOffid
            StatusId: leaveStatus, //@status
            Reason: leaveStatusOnEdit ? null : reason.trim(),
            UserId: Number(EmployeeId), //@userId
            LeaveBalance: state.leaveBalance,
            RequestorId: state.requestorId,
            CreatedBy: Number(EmployeeId),
            ApproverId: state.approverId,
            CompOffdate: state.compOffdate,
            // Reason: reason === "" ? null : reason.trim(), //@reason
            // EmployeeRole: state.role,
          };

          await submitApiCall(submitObj);
        }
      }
      // else {
      //   submitObj = {
      //     RequestorId: requestor.value,
      //     ApproverId: approver.value,
      //     FYIUsersList: FYIUsers,
      //     FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
      //     FromDateLeaveType: fromDateLeaveType.value,
      //     ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
      //     ToDateLeaveType: toDateLeaveType.value,
      //     LeaveDays: leaveDays,
      //     leaveType: leaveType.value,
      //     ResonId: leaveReason.value,
      //     Reason: reason === "" ? null : reason.trim(),
      //     RequestStatus: 2, //Pending by default when requesting leave
      //     IsActive: true,
      //     CreatedBy: Number(EmployeeId),
      //     CreatedDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
      //     IsPlanned: isPlanned,
      //   };
      // }
    }
    if (action === "reset") {
      resetFunc();
    }
  };

  const getLeaveRequestMasterData = async () => {
    showLoader();
    let requestParams = {
      CompOffDate: state.compOffdate.slice(0, 10),
      UserId: state.requestorId,
      // CompOffId: state.id,
      // start: start,
      // pageSize: pageSize,
      // sortColumn: sortColumn,
      // SortOrder: sortDirection,
      // searchText: searchText,
      // RoleId: roleForData,
      // UserId: Number(EmployeeId),
    };

    const { data } = await APICall(
      GetCompOffDataBasedId,
      "POST",
      requestParams
    );

    const leaveRequestsMasterData = data?.map((ele: any) => {
      return {
        ...ele,
      };
    });

    setCount(data?.count);
    setLeaveRequestMasterData(leaveRequestsMasterData);

    hideLoader();
  };

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "requestorId",
      label: "requestorId",
      options: {
        display: false,
      },
    },
    {
      name: "engagement",
      label: "Engagment Name",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "taskTitle",
      label: "Task/Ticket/Issue Name",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "hoursSpend",
      label: "Working Hours",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
  ];

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    customSearchRender: debounceSearchRender(500),
    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  return (
    <>
      <Heading title={"Request CompOff - Approve"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Employee Name <sup>*</sup>
              </label>
              <SelectForm
                options={approverOptions}
                placeholder="Select"
                isDisabled={true}
                value={requestor}
                onChange={
                  () => {}
                  // (event) => selectOnChange(event, "requestor")
                }
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{formErrors["requestor_isEmpty"]}</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Approver Name <sup>*</sup>
              </label>
              <SelectForm
                options={approverOptions}
                placeholder="Select"
                isDisabled={true}
                value={approver}
                onChange={
                  () => {}
                  // (event) => selectOnChange(event, "approver")
                }
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{formErrors["approver_isEmpty"]}</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Working Date (CompOff) <sup>*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="To date"
                  disabled={state !== null ? true : false}
                  value={state.compOffdate}
                  onChange={() => {}}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" {...params} />
                  )}
                  minDate={state.compOffdate}
                  PopperProps={{
                    disablePortal: true,
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 8],
                        },
                      },
                      {
                        name: "preventOverflow",
                        options: {
                          enabled: true,
                          boundariesElement: "viewport",
                        },
                      },
                    ],
                  }}
                />
              </LocalizationProvider>
              <p style={{ color: "red" }}>{formErrors["toDate_isEmpty"]}</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Comp-Off Leave Balance <sup>*</sup>
              </label>
              <InputForm
                placeholder={"Leave days"}
                isDisabled={true}
                textArea={false}
                value={state.leaveBalance}
                onChange={(e) => handleTextEvent(e, "leaveDays")}
                className="numRight"
                type="number"
                onKeyPress={(event) => {
                  if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              <p style={{ color: "red" }}>
                {formErrors["leaveBalance_isEmpty"]}
              </p>
            </div>
          </div>

          {state !== null && state.role !== "viewer" && (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group clearfix">
                  <label>
                    {
                      // state.role === "manager"
                      //   ? "Cancel Comp-Off"
                      //   :
                      state.role === "approver"
                        ? "Approve Comp-Off"
                        : state.role === "self"
                        ? "Cancel Comp-Off"
                        : "Approve Comp-Offs"
                    }
                    <sup>*</sup>
                  </label>
                  <div>
                    <label
                      htmlFor="custom-switch"
                      style={{ float: "left" }}
                      className="mr-2"
                    >
                      No
                    </label>
                    <Form style={{ float: "left" }}>
                      <Form.Check
                        type="switch"
                        id="custom-switch"
                        label=""
                        onChange={(e) => {
                          setLeaveStatusOnEdit(e.target.checked);
                          if (leaveStatusOnEdit == true) {
                            setReason(null);
                          }
                        }}
                        // checked={leaveStatusOnEdit}
                        checked={
                          leaveStatusOnEdit !== null
                            ? leaveStatusOnEdit
                            : state.StatusId === 1
                        }
                      />
                    </Form>
                    <label
                      htmlFor="custom-switch"
                      style={{ float: "left" }}
                      className="ml-2"
                    >
                      Yes
                    </label>
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="col-lg-12">
            <div className="form-group">
              <label>
                Reason <sup>*</sup>
              </label>
              <InputForm
                placeholder={"Reason"}
                isDisabled={
                  state.role === "viewer" || leaveStatusOnEdit === true
                    ? true
                    : false
                }
                textArea={true}
                // value={state.reason}
                value={reason}
                rows={4}
                onChange={(e) => handleTextEvent(e, "reason")}
              />
              <p style={{ color: "red" }}>{formErrors["reason_isEmpty"]}</p>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <button onClick={() => navigate(-1)} className="btn btn-reset">
                <i className="fa fa-chevron-left"></i>
              </button>
              <button
                onClick={() => submitFunc("submit")}
                className="btn btn-submit"
                disabled={
                  // state.approverId === 0
                  //   ? true
                  //   : false ||
                  //     (state !== null &&
                  //       state.role === "self" &&
                  //       leaveStatusOnEdit === false)
                  //   ? true
                  //   : false || (state !== null && state.role === "viewer")
                  //   ? true
                  //   : false
                  state.approverId === 0 || state.role === "viewer"
                }
              >
                Submit
              </button>
            </div>
          </div>
          <div className="col-lg-12 mt-3">
            <DynamicGrid
              options={options}
              data={LeaveRequestMasterData}
              columns={gridColumns}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CompOffLeaveMasterEdit;
